import { render, staticRenderFns } from "./TabbedPortlet.vue?vue&type=template&id=4463a734&"
import script from "./TabbedPortlet.vue?vue&type=script&lang=js&"
export * from "./TabbedPortlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports